const ListIcon = () => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="26.005" height="19.477" viewBox="0 0 26.005 19.477">
  <g id="list_1_" data-name="list (1)" transform="translate(0 -64.267)">
    <path id="Path_1659" data-name="Path 1659" d="M145.617,64.267H130.926a2.394,2.394,0,0,0,0,4.788h14.691a2.394,2.394,0,0,0,0-4.788Z" transform="translate(-122.005)" fill="inherit"/>
    <path id="Path_1660" data-name="Path 1660" d="M2.394,64.267a2.394,2.394,0,1,0,2.394,2.394A2.4,2.4,0,0,0,2.394,64.267Z" fill="inherit"/>
    <path id="Path_1661" data-name="Path 1661" d="M2.394,208.867a2.394,2.394,0,1,0,2.394,2.394A2.4,2.4,0,0,0,2.394,208.867Z" transform="translate(0 -137.256)" fill="inherit"/>
    <path id="Path_1662" data-name="Path 1662" d="M2.394,353.467a2.394,2.394,0,1,0,2.394,2.394A2.4,2.4,0,0,0,2.394,353.467Z" transform="translate(0 -274.511)" fill="inherit"/>
    <path id="Path_1663" data-name="Path 1663" d="M145.617,208.867H130.926a2.394,2.394,0,0,0,0,4.788h14.691a2.394,2.394,0,0,0,0-4.788Z" transform="translate(-122.005 -137.256)" fill="inherit"/>
    <path id="Path_1664" data-name="Path 1664" d="M145.617,353.467H130.926a2.394,2.394,0,0,0,0,4.788h14.691a2.394,2.394,0,0,0,0-4.788Z" transform="translate(-122.005 -274.511)" fill="inherit"/>
  </g>
</svg>

  )
}
export default ListIcon

